<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4">404</h1>
            <h4 class="pt-3">Oops! Estas perdid@.</h4>
            <p class="text-muted">No se encontró la página que buscas.</p>
          </div>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col md="3">
            <b-button class="col-sm-12" variant="success" @click="irHome()">Inicio</b-button>
        </b-col>        
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Page404',
  methods:{
    irHome(){
      this.$router.push('dashboard') // redireccionar al home
    }
  }
}
</script>
